import { reactive, UnwrapRef, computed } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { ExtUserListItemData } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import store from '@/renderer/store';
export type ExtUserInfo = {
  userId: number;
  nickname: string;
  countryCode: string;
  phoneNumber: string;
  comment: string;
  allowSms: boolean;
};
type Handler = {
  itemData: UnwrapRef<ExtUserInfo>;
  methods: {
    deleteUser: (selectedList: Array<any>) => Promise<boolean>;
    optUser: (forbidden: boolean, selectedList: Array<any>) => Promise<boolean>;
    addUser: (value: ExtUserInfo) => Promise<boolean>;
    editUser: (value: ExtUserInfo) => Promise<boolean>;
  };
};
export default function userActionHandler(): Handler {
  const enabledValue = computed(() => {
    const { defaultUserOptions } = store.getters;
    return defaultUserOptions.enabled;
  });
  const itemData = reactive<ExtUserInfo>({
    userId: -1,
    nickname: '',
    countryCode: '+86',
    phoneNumber: '',
    comment: '',
    allowSms: true,
  });
  const methods = {
    async deleteUser(selectedList: Array<ExtUserListItemData>) {
      let isSuccessful = true;
      tips.loading(i18n_t('正在处理'), 0);
      try {
        await smh.userAPI.deleteExtUsers({
          userIds: selectedList.map(item => item.id).join(','),
        });
        tips.success(i18n_t('删除成功'));
      } catch (e: any) {
        isSuccessful = false;
        tips.error(e);
      }
      return isSuccessful;
    },
    async optUser(forbidden: boolean, selectedList: Array<ExtUserListItemData>) {
      let isSuccessful = true;
      tips.loading(i18n_t('正在处理'), 0);
      try {
        await smh.userAPI.toggleExtUsersAvailable({
          userIds: selectedList.map(item => item.id).join(','),
          enabled: !forbidden,
        });
        const tip = forbidden ? i18n_t('冻结') : i18n_t('启用');
        tips.success(
          i18n_t('{tip}成功', {
            tip,
          }),
        );
      } catch (e: any) {
        isSuccessful = false;
        tips.error(e);
      }
      return isSuccessful;
    },
    async addUser(value: ExtUserInfo) {
      let isSuccessful = true;
      tips.loading(i18n_t('正在处理'), 0);
      try {
        await smh.userAPI.createExtUser({
          countryCode: value.countryCode,
          phoneNumber: value.phoneNumber,
          nickname: value.nickname,
          comment: value.comment,
          enabled: enabledValue.value,
        });
        tips.success(i18n_t('添加成功'));
      } catch (e: any) {
        isSuccessful = false;
        tips.error(e);
      }
      return isSuccessful;
    },
    async editUser(value: ExtUserInfo) {
      let isSuccessful = true;
      tips.loading(i18n_t('正在处理'), 0);
      try {
        await smh.userAPI.updateExtUser({
          userId: value.userId,
          nickname: value.nickname,
          comment: value.comment,
        });
        tips.success(i18n_t('修改成功'));
      } catch (e: any) {
        isSuccessful = false;
        tips.error(e);
      }
      return isSuccessful;
    },
  };
  return {
    itemData,
    methods,
  };
}
